import { Box, Container, Fade, Text } from "@chakra-ui/react";
import { FC } from "react";
import { useParams } from "react-router-dom";

import {
  Banner,
  Card,
  PageHeader,
} from "../../shared/components";
import bannerImage from "../../img/bannerTv/telew_top.jpg";
import { BannerClass } from "../../shared/components/Banner/utils";
import { useUserData } from "../../hooks/useUserData";
import { env } from "../../env";
import { useStbList } from "../../hooks/useStbList";
import { formatClock, timestampToDateString } from "../../shared/utils";

export const TvDevice: FC = () => {
  const { id } = useParams();
  const stbList = useStbList();
  const tvDeviceData = stbList.data.find((element) => element.id === id);
  const userData = useUserData();

  const {
    serialNumber,
    creationDate,
    // activeDate,
    macAddress,
    ipAddress,
    // iptvProgram,
    status,
    model,
    // description,
  } = tvDeviceData || {};



  const bannerDetails = new BannerClass(env.REACT_APP_USE_USER_CODE === 'true' ? userData.data?.usercode : userData.data?.userno);



  return (
    <>
      <Banner bannerImage={bannerImage} {...bannerDetails} />
      <Fade in={true}>
        <Container maxWidth={"container.xl"} flexDir={"column"}  >
          <PageHeader title={model} buttonText="Urządzenia" />
          <Box
            bg="white"
            p={6}
            mt={6}
            borderRadius="md"
            width="100%"
          >
            <Box pl={2} >
              <Box mb={3}>
                <Text fontWeight="semibold">Model</Text>
                <Text>{model || 'Brak'}</Text>
              </Box>
              <Box mb={3}>
                <Text fontWeight="semibold">Adres IP</Text>
                <Text>{ipAddress || 'Brak'}</Text>
              </Box>
              <Box mb={3}>
                <Text fontWeight="semibold">MAC</Text>
                <Text>{macAddress || 'Brak'}</Text>
              </Box>
              <Box mb={3}>
                <Text fontWeight="semibold">Numer seryjny</Text>
                <Text>{serialNumber || 'Brak'}</Text>
              </Box>
              <Box mb={3}>
                <Text fontWeight="semibold">Status</Text>
                <Text>{status || 'Brak'}</Text>
              </Box>
              <Box mb={3}>
                <Text fontWeight="semibold">Odczytano</Text>
                <Text>{creationDate ? (timestampToDateString(Number(creationDate) * 1000) + ' ' + formatClock(Number(creationDate) * 1000)) : "Brak daty"}</Text>
              </Box>
            </Box>
          </Box>
        </Container>
      </Fade>
    </>
  );
};
